import { render, staticRenderFns } from "./ListStock.vue?vue&type=template&id=66470e68&scoped=true"
import script from "./ListStock.vue?vue&type=script&lang=js"
export * from "./ListStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66470e68",
  null
  
)

export default component.exports